<template>
  <WhitePage :loading="loading">
    <title-bar>ステータス</title-bar>
    <div class="eno">ENo.{{ eno }}</div>
    <h2>{{name}}</h2>
    <b-container>
      <b-row>
        <b-col>
          <b-img :src="image" center width="210px" height="300px" 
            style="padding: 10px"
            v-if="image" />
          <b-img :src="iconURL || noimage" center width="120px" height="120px" 
            style="padding: 10px"
            v-else
          />
        </b-col>
        <b-col cols="7">
          <div v-html="note" class="note">
          </div>
        </b-col>
      </b-row>
      <b-table-simple bordered small class="status">
        <b-tbody>
          <b-tr v-for="(r,k1) in keyTable" :key="k1"
            class="base-status">
            <template v-for="(v,k2) in r">
              <b-td colspan="10" :key="`${k1}-${k2}-key`">
                {{v}}
              </b-td>
              <b-td colspan="5" :key="`${k1}-${k2}-value`">
                <template v-if="worldStatus && worldStatus[v] !== undefined">
                  {{worldStatus[v]}}({{status[v]||0}})
                </template>
                <template v-else>
                  {{status[v]}}
                </template>
              </b-td>
            </template>
          </b-tr>
          <b-tr>
            <b-td colspan="60">
              <b-link v-if="!showOtherKeys"
                @click="showOtherKeys = true">
                ▲その他ステータス
              </b-link>
              <b-link v-else
                @click="showOtherKeys = false">
                ▼その他ステータス
              </b-link>
            </b-td>
          </b-tr>
          <template v-if="showOtherKeys">
            <b-tr v-for="(r,k1) in otherKeyTable" :key="k1"
              class="other-status">
              <template v-for="(v,k2) in r">
                <b-td colspan="8" :key="`${k1}-${k2}-key`">
                  {{v}}
                </b-td>
                <b-td colspan="4" :key="`${k1}-${k2}-value`">
                  <template v-if="worldStatus && worldStatus[v] !== undefined">
                    {{worldStatus[v]}}({{status[v]||0}})
                  </template>
                  <template v-else>
                    {{status[v]}}
                  </template>
                </b-td>
              </template>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
      <b-row>
        <b-col>
          <h5>所持カード({{cardList.length}}/{{maxCard}}枚)</h5>
          <card-list :list="cardList" :master="cardMaster" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5>スタンプ({{ achievementNum }} / {{ achievementMaxNum }})</h5>
          <div class="achievements">
            <div v-for="a in achievementList" :key="a.RID" 
              class="achievement" :id="'achievement-'+a.RID">
              <b-img :src="achievementMaster | achievementIcon(a.RID) | coalesceImage" 
                :width="100" :height="100" />
              <div class="achievement-front">{{ achievementMaster | achievementName(a.RID) }}</div>
              <b-tooltip v-if="achievementMaster[a.RID]" 
                :target="'achievement-'+a.RID" triggers="hover">
                <div v-html="achievementMaster[a.RID].memo"></div>
              </b-tooltip>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5>アイコン</h5>
          <div style="display: flex; flex-wrap: wrap">
            <b-img :src="icon.url||noimage" width="60px" height="60px" style="margin: 5px" 
              v-for="icon in iconList" :key="icon.value"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
    <pagenate>
      <template v-if="!$route.params.id" #previous>
        <b-icon icon="chevron-left" />
        <router-link to="/result">今日のできごと</router-link>
      </template>
      <template v-else #next>
        <router-link :to="`/result/${$route.params.id}`">今日のできごと</router-link>
        <b-icon icon="chevron-right" />
      </template>
    </pagenate>
  </WhitePage>
</template>

<script>
import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import TitleBar from '@/components/TitleBar'
import CheckLogin from '@/components/mixin-checkLogin'
import _ from 'lodash'
import noimage from '@/assets/noimage.png'
import Pagenate from '@/components/Pagenate'
import CardList from '@/components/CardList'
export default {
  filters: {
    achievementName (master, key) {
      return master[key] ? master[key].name : '謎の実績'
    },
    achievementMemo (master, key) {
      return master[key] ? master[key].memo : '謎の実績'
    },
    achievementIcon (master, key) {
      return master[key] ? master[key].image : null
    },
    coalesceImage (image) {
      return image || './img/noimage.png'
    }
  },
  components: {
    WhitePage,
    TitleBar,
    Pagenate,
    CardList
  },
  data () {
    return {
      eno: 0,
      nickname: '',
      name: '',
      memo: '',
      note: '',
      status: {},
      worldStatus: {},
      keys: [],
      otherKeys: [],
      showOtherKeys: false,
      icon: '',
      iconList: [],
      image: '',
      loading: false,
      cardList: [],
      cardMaster: {},
      maxCard: 0,
      achievementList: [],
      achievementMaster: {},
      achievementMaxNum: 0
    }
  },
  computed: {
    keyTable () {
      return _.chunk(this.keys, 4)
    },
    otherKeyTable () {
      return _.chunk(this.otherKeys, 5)
    },
    noimage () {
      return noimage
    },
    iconURL () {
      var s = _.find(this.iconList,v => v.value===this.icon)
      return s && s.url
    },
    achievementNum () {
      return this.achievementList.length
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.eno = response.eno
      this.nickname = response.nickname
      this.name = response.name
      this.memo = response.memo
      this.note = response.note
      this.icon = response.icon
      this.iconList = response.iconList
      this.image = response.image
      this.status = response.status
      this.keys = ['HP','EP','STR','INT','VIT','MND','DEX','AGI']
      this.status.forIn((k)=>{ !this.keys.contains(k) && this.otherKeys.push(k) })
      this.worldStatus = response.worldStatus
      this.worldStatus.forIn((k)=>{ !this.keys.contains(k) && this.keys.push(k) })
      this.cardList = response.cardList
      this.cardMaster = response.cardMaster
      this.maxCard = response.maxCard
      this.achievementList = response.achievementList
      this.achievementMaster = response.achievementMaster
      this.achievementMaxNum = response.achievementMaxNum
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getProfile', route.params)
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    if(!this.$route.params.id){
      this.checkLogin()
    }
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style lang="scss" scoped>
.eno {
  position: relative;
  top: 20px;
  font-size: medium;
}
.note {
  width: calc(100%-20px);
  height: calc(100%-20px);
  min-height: 100px;

  margin: 10px;

  background-color: rgba(255,255,255,0.2);
  background-blend-mode: lighten;
  border-image: url('../assets/ui/frame3.png') 5;
  border-style:solid;
  border-width: 5px;

  ::v-deep .ql-size-large {
    font-size: 1.5em;
  }
  ::v-deep .ql-size-small {
    font-size: .75em;
  }
  ::v-deep .ql-size-huge {
    font-size: 2.5em;
  }
}
.status {
  td {
    width: 16px;
  }

  .other-status {
    font-size: smaller;
  }
}
.achievements {
  display: flex;
  flex-wrap: wrap;

  .achievement {
    margin: 5px;

    position: relative;

    .achievement-front {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      color: transparent;

      &:hover {
        background-color: rgba(0,0,0,0.3);
        color: #FFF;
      }

    }
  }
}
</style>
